module.exports = __webpack_public_path__ + "static/who-we-are-banner-a6cccb5b8dfcd5da5d99b9d3b83a3991.png";